import { IonCol, IonGrid, IonItemDivider, IonLabel, IonList, IonRow } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { IOption, IPNNVOptions } from '../../../common/common.types'
import SingleSelect from '../../../components/singleSelect/SingleSelect.component'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'
import { getPaymentInformationOptionsSelector } from '../../options/selectors'
import { getPaymentInformationSelector } from '../selectors'
import {
  savePaymentInformation,
  setPrimaryMethodOfPayment,
  setPrimaryMethodOfPaymentPNNV,
  setPriorAuthorizationPayer,
  setX12PayerType,
} from '../store/paymentInformation.actions'

const PaymentInformationContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { isTablet } = useDeviceMetrics()
  const paymentInformation = useSelector(getPaymentInformationSelector)
  const { priorAuthorizationPayer, x12PayerType, primaryMethodOfPayment, primaryMethodOfPaymentPNNV } =
    paymentInformation
  const paymenInformationOptions = useSelector(getPaymentInformationOptionsSelector)
  const { primaryMethodOfPaymentOptions, x12PayerTypeOptions, priorAuthorizationPayerOptions } =
    paymenInformationOptions

  const setPrimaryMethodOfPaymentOnChange = (option: IOption) => {
    dispatch(setPrimaryMethodOfPayment(option))
    dispatch(savePaymentInformation())
  }

  const setPrimaryMethodOfPaymentPNNVOnChange = (option: IPNNVOptions) => {
    dispatch(setPrimaryMethodOfPaymentPNNV(option))
    dispatch(savePaymentInformation())
  }

  const setX12PayerTypeOnChange = (option: IOption) => {
    dispatch(setX12PayerType(option))
    dispatch(savePaymentInformation())
  }

  const setPriorAuthorizationPayerOnChange = (option: IOption) => {
    dispatch(setPriorAuthorizationPayer(option))
    dispatch(savePaymentInformation())
  }

  return (
    <>
      <IonItemDivider color='light' className='ion-padding'>
        <IonLabel className='grid-item-divider-label' color='medium'>
          {t('paymentInformation.paymentInformationDetails')}
        </IonLabel>
      </IonItemDivider>

      <IonList className={isTablet ? 'ion-margin-horizontal' : ''}>
        <IonGrid className='no-padding'>
          {/* <hr className='field-divider' /> */}
          <IonRow>
            <IonCol className='picklist'>
              <SingleSelect
                dataTestID='PrimaryMethodOfPayment'
                selectedOption={primaryMethodOfPayment}
                listHeader={t('paymentInformation.primaryMethodOfPayment')}
                label={t('paymentInformation.primaryMethodOfPayment')}
                options={primaryMethodOfPaymentOptions}
                action={setPrimaryMethodOfPaymentOnChange}
                selectedPNNVOption={primaryMethodOfPaymentPNNV}
                pnnvAction={setPrimaryMethodOfPaymentPNNVOnChange}
              />
            </IonCol>
          </IonRow>
          <hr className='field-divider' />
          <IonRow>
            <IonCol className='picklist'>
              <SingleSelect
                dataTestID='X12PayerType'
                selectedOption={x12PayerType}
                listHeader={t('paymentInformation.x12PayerType')}
                label={t('paymentInformation.x12PayerType')}
                options={x12PayerTypeOptions}
                action={setX12PayerTypeOnChange}
              />
            </IonCol>
          </IonRow>
          <hr className='field-divider' />
          <IonRow>
            <IonCol className='picklist'>
              <SingleSelect
                dataTestID='PriorAuthorizationPayer'
                selectedOption={priorAuthorizationPayer}
                listHeader={t('paymentInformation.priorAuthorizationPayer')}
                label={t('paymentInformation.priorAuthorizationPayer')}
                options={priorAuthorizationPayerOptions}
                action={setPriorAuthorizationPayerOnChange}
              />
            </IonCol>
          </IonRow>
          <hr className='field-divider' />
        </IonGrid>
      </IonList>
    </>
  )
}

export default PaymentInformationContent
